import { errorsFactory } from '../utils';

const NoFilesError = errorsFactory('NoFilesError');

export default NoFilesError;
